import {
  U21Chip,
  U21ShowMoreText,
  U21Spacer,
  U21Typography,
} from 'app/shared/u21-ui/components';
import { EvaluationFlag } from 'app/modules/detectionModels/components/ConditionBreakdown/Operand';
import styled from 'styled-components';
import { Condition } from 'app/modules/detectionModels/components/ConditionBreakdown/Condition';
import { isUndefined } from 'lodash';

interface ConditionCardProps {
  op: any;
  variables?: any;
  isUnsupportedTags?: boolean;
}

export const ConditionCard = ({
  op,
  variables,
  isUnsupportedTags = false,
}: ConditionCardProps) => {
  const { evaluation_result: evaluationResult } = op;

  return (
    <DetailedConditionCard spacing={2}>
      <U21Spacer horizontal>
        <EvaluationFlag evaluationResult={evaluationResult} />
        {isUnsupportedTags ? (
          <U21Typography variant="subtitle1">
            Condition results cannot be displayed
          </U21Typography>
        ) : (
          <U21Typography variant="subtitle1">
            Condition was {!evaluationResult && 'not'} met:
          </U21Typography>
        )}
      </U21Spacer>
      <U21Spacer>
        {isUnsupportedTags && (
          <U21Typography variant="body2">
            This condition was evaluated, but the results cannot be displayed.
            Entity tags are not supported in this view.
          </U21Typography>
        )}
        <U21Typography variant="subtitle2">Evaluated as</U21Typography>
        <U21Spacer wrap horizontal>
          <Condition op={op} swapWithSnapshotValue showMenu={false} />
        </U21Spacer>
      </U21Spacer>
      {!isUnsupportedTags && (
        <U21Spacer horizontal>
          <VariableSpacer>
            <U21Typography variant="subtitle2">
              Variables in this condition
            </U21Typography>
            {variables.map((variable) => {
              return (
                <VariableChip key={variable.name}>
                  <U21ShowMoreText
                    variant="body2"
                    limit={15}
                    value={variable.name}
                  />
                </VariableChip>
              );
            })}
          </VariableSpacer>
          <U21Spacer>
            <U21Spacer>
              <U21Typography variant="subtitle2">
                Value at evaluation
              </U21Typography>
              {variables.map((variable) => {
                const snapshotValue = variable.snapshot_value;
                let valueToRender = snapshotValue;
                if (isUndefined(snapshotValue)) {
                  valueToRender = 'undefined';
                } else if (typeof snapshotValue === 'boolean') {
                  // need to convert boolean to string to render in chip
                  valueToRender = snapshotValue.toString();
                }
                return (
                  <VariableChip key={variable.name}>
                    {valueToRender}
                  </VariableChip>
                );
              })}
            </U21Spacer>
          </U21Spacer>
        </U21Spacer>
      )}
    </DetailedConditionCard>
  );
};

const VariableChip = styled(U21Chip)`
  width: fit-content;
`;

const VariableSpacer = styled(U21Spacer)`
  width: 200px;
`;

const DetailedConditionCard = styled(U21Spacer)`
  max-width: 420px;
  max-height: 260px;
  padding: 16px;
`;
